<script setup>
import { watch } from 'vue';

import { useRouter } from 'vue-router';

import { storeToRefs } from 'pinia';

import { ElMessageBox } from 'element-plus';

import { resetGateGuardDedup } from '@/api/interceptors/gateGuard.js';
import { useBillingGate } from '@/composables/useBillingGate.js';
import { useBillingGateDialogStore } from '@/stores/billingGateDialog.js';

const router = useRouter();
const store = useBillingGateDialogStore();
const { isOpen } = storeToRefs(store);
const { isHardGated, gateReason } = useBillingGate();

watch(isOpen, (open) => {
  if (!open) return;

  // Cancel mirrors the router's gate: it stays only when the user can actually
  // go back into the app. A trial-ended gate (hard_gate, or soft_gate with
  // gateReason 'trial') route-blocks every page, so there is nowhere to cancel
  // back to — "Open billing" is the only way out. A dunning subscriber
  // (gateReason 'subscription') keeps in-app access, and an absent gateReason
  // fails open to today's behavior (Cancel shown on soft gate).
  const trialBlocked = isHardGated.value || gateReason.value === 'trial';
  const dunning = gateReason.value === 'subscription';

  ElMessageBox.confirm(
    dunning
      ? "We couldn't process your payment, and changes to marketplace data are no longer available. Update your payment method to restore full access."
      : 'Your trial period has ended, and changes to marketplace data are no longer available. Subscribe to restore full access.',
    'Subscription required',
    {
      confirmButtonText: 'Open billing',
      cancelButtonText: 'Cancel',
      showCancelButton: !trialBlocked,
      type: 'warning',
      showClose: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      callback: (action) => {
        store.close();
        resetGateGuardDedup();
        if (action === 'confirm') {
          router.push('/billing');
        }
      },
    },
  );
});
</script>

<template><span /></template>
